const HTTP_STATUS_CONTSTANTS = {
  OK: 200,
  ERROR_CODE_401: 401,
  RESPONSE_OK: 0,
  SERVER_ERROR: 'E0',
  ERROR: 400,
};

export default HTTP_STATUS_CONTSTANTS;
